<template>
    <div class="table-responsive">
        <p style="margin-bottom: 12px;">Commission statements for each month are ready after 14 days.</p>
        <div class="data-loader" v-if="loader"></div>
        <div class="table-outer">
            <table class="table-style2">
                <thead>
                    <tr class="business-qualifications-header-table">
                        <th v-for="(header, headerId) in tableHeaders"
                            :key="headerId">
                            <p>{{ header }}</p>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(statement, index) in tableRows"
                        v-if="tableRows.length > 0"
                        class="row-items">
                        <td>
                            {{ statement.date_from }} - {{ statement.date_to }}
                        </td>
                        <td>
                            FND {{ money.format(statement.total_amount, 'fnd') }}
                        </td>
                        <td>
                            <a class="button--primary"
                               :href="downloadLink(statement.month_period)"
                               target="_blank">Download PDF</a>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-if="tableRows.length <= 0 && !loader"
               style="margin: 24px 0;">No results.</p>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['invoice', 'money', 'monthlyStatement'],
        data () {
            return {
                loader      : true,
                tableHeaders: {
                    date: 'Date',
                    value: 'Value',
                    invoice: 'Invoice'
                }
            }
        },
        computed: {
            tableRows () {
                return this.$store.getters.monthlyStatement;
            }
        },
        methods: {
            downloadLink (period) {
                return this.monthlyStatement.getDownloadLink(period);
            }
        },
        created () {
            this.monthlyStatement.fetchData().then(() => {
                this.loader = false;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/partials/section/content/monthly-statement/MonthlyStatementTable.vue